import { Box, Flex, Grid, GridItem, HStack, Text } from "@chakra-ui/layout";
import {
  Button,
  NumberInput as ChakraNumberInput,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberInputField,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  Card,
  DataTable,
  LoadingOverlay,
  NumberInput,
} from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import { FiltersPanelRoot } from "@src/utils/components/filters/components/filters-panel";
import { FiltersPanelFilters } from "@src/utils/components/filters/components/filters-panel-filters";
import { FiltersPanelSearch } from "@src/utils/components/filters/components/filters-panel-search";
import { currency } from "@src/utils/formatters";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

export const MatchPaymentModal = observer(function MatchPaymentModal() {
  const { matchPaymentModalStore: store } = useStore();

  return (
    <Modal
      isOpen={store.disclosure.isOpen}
      onClose={store.disclosure.onClose}
      scrollBehavior="inside"
      trapFocus={false}
    >
      <ModalOverlay />
      <ModalContent minW="85vw" h="85vh" minH="85vh">
        <ModalHeader display="inline-flex">
          <Text fontWeight="inherit">
            <Trans>Match payment</Trans>
          </Text>
          {/*
          store.selectedAccountMove && (
            <Text
              color="gray.600"
              fontSize="md"
              textAlign="center"
              marginY="auto"
            >
              &nbsp;
              <Trans>- Paid -</Trans>
              &nbsp;
              {currency.formatByWorkspace(store.selectedAccountMove.amount)}
            </Text>
          )
          */}
          <ModalCloseButton isDisabled={store.isSubmitting} />
        </ModalHeader>
        <ModalBody>
          {store.selectedDocument && (
            <Card mb="4">
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <Trans>Document no</Trans>
                    </Th>
                    <Th>
                      <Trans>Amount (with VAT)</Trans>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>{store.selectedDocument.number}</Td>
                    <Td>
                      {currency.formatByCurrency(
                        store.selectedDocument.amount,
                        store.selectedDocument.currency,
                      )}
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Card>
          )}

          {store.selectedMoves.length > 0 && (
            <Grid templateColumns="0.775fr 0.225fr" my="4" gap="4">
              <GridItem>
                <Card h="full" pos="relative" pt="4">
                  <Text fontSize="xl" px="6" pb="2" fontWeight="bold">
                    <Trans>Selected moves</Trans>
                  </Text>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th>
                          <Trans>Amount</Trans>
                        </Th>
                        {store.selectedMovesIncludeForeignCurrency ? (
                          <>
                            <Th>
                              <Trans>Exchange rate</Trans>
                            </Th>
                            <Th>
                              <Trans>Converted amount</Trans>
                            </Th>
                          </>
                        ) : (
                          <></>
                        )}
                        <Th />
                      </Tr>
                    </Thead>
                    <Tbody>
                      {store.selectedMoves.map((move) =>
                        move.isEditEnabled.value ? (
                          <Tr key={`${move.$.moveId.$}-editable`}>
                            <Td>
                              <NumberInput
                                currency
                                value={move.amountInputValue}
                                onChange={move.handleAmountChange}
                                suffix={move.currency.code}
                                error={move.$.amount.error}
                              />
                            </Td>
                            {move.hasForeignCurrency ? (
                              <>
                                <Td>
                                  <NumberInput
                                    currency
                                    value={move.$.exchangeRate.value}
                                    onChange={move.$.exchangeRate.onChange}
                                    prefix={move.exchangeRatePrefix}
                                    suffix={move.currency.code}
                                    error={move.$.exchangeRate.error}
                                    inputStyle={{
                                      paddingInlineStart: "16",
                                    }}
                                    prefixStyles={{
                                      minW: "fit-content",
                                    }}
                                  />
                                </Td>
                                <Td>
                                  {move.referenceCurrency
                                    ? currency.formatByCurrency(
                                        move.denominatedAmountInDocumentCurrency,
                                        move.referenceCurrency,
                                      )
                                    : null}
                                </Td>
                              </>
                            ) : store.selectedMovesIncludeForeignCurrency ? (
                              <>
                                <Td />
                                <Td />
                              </>
                            ) : (
                              <></>
                            )}
                            <Td>
                              <HStack justify="end" spacing="2">
                                <Button
                                  colorScheme="grey"
                                  onClick={move.handleEditCancel}
                                  size="sm"
                                  variant="outline"
                                >
                                  <Trans>Cancel</Trans>
                                </Button>
                                <Button onClick={move.handleEditSave} size="sm">
                                  <Trans>Save</Trans>
                                </Button>
                              </HStack>
                            </Td>
                          </Tr>
                        ) : (
                          <Tr key={`${move.$.moveId.$}-noneditable`}>
                            <Td>
                              {currency.formatByCurrency(
                                move.$.amount.$,
                                move.currency,
                              )}
                            </Td>
                            {move.hasForeignCurrency ? (
                              <>
                                <Td>
                                  {move.exchangeRatePrefix}
                                  &nbsp;
                                  {move.formattedExchangeRate}
                                </Td>
                                <Td>
                                  {store.selectedDocument?.currency
                                    ? currency.formatByCurrency(
                                        move.denominatedAmountInDocumentCurrency,
                                        store.selectedDocument?.currency,
                                      )
                                    : null}
                                </Td>
                              </>
                            ) : store.selectedMovesIncludeForeignCurrency ? (
                              <>
                                <Td />
                                <Td />
                              </>
                            ) : (
                              <></>
                            )}
                            <Td>
                              <Flex justify="end">
                                <IconButton
                                  aria-label={t`Selected move value edit`}
                                  colorScheme="grey"
                                  icon={<Icon name="edit-02" />}
                                  onClick={() => move.isEditEnabled.on()}
                                  variant="ghost"
                                />
                                <IconButton
                                  aria-label={t`Unselect move`}
                                  colorScheme="red"
                                  icon={<Icon name="trash-03" />}
                                  onClick={() => store.handleMoveDelete(move)}
                                  variant="ghost"
                                />
                              </Flex>
                            </Td>
                          </Tr>
                        ),
                      )}
                    </Tbody>
                  </Table>
                </Card>
              </GridItem>

              <GridItem>
                <Card h="full" px="6" py="4">
                  <Box pos="sticky" top="0">
                    <Text fontSize="xl" fontWeight="bold">
                      <Trans>Balance</Trans>
                    </Text>
                    <Text
                      mt="2"
                      fontSize="2xl"
                      fontWeight="bold"
                      color={store.balanceColor}
                    >
                      {store.balance !== 0 &&
                        (store.isBalancePositive ? (
                          <>
                            <Trans>Left</Trans>
                            &nbsp;
                          </>
                        ) : (
                          <>
                            <Trans>Over</Trans>
                            &nbsp;
                          </>
                        ))}
                      {store.formattedBalance}
                    </Text>

                    {!store.isBalancePositive && (
                      <Text color={store.balanceColor} mt="2">
                        <Trans>Can't match more than document value</Trans>
                      </Text>
                    )}
                  </Box>
                </Card>
              </GridItem>
            </Grid>
          )}

          <DataTable>
            <DataTable.NavBar>
              <Box py="4">
                <FiltersPanelRoot filters={store.where}>
                  <HStack
                    w="full"
                    justify="space-between"
                    spacing="4"
                    align="center"
                    mb="4"
                  >
                    <HStack spacing="2">
                      <FiltersPanelSearch onSearch={store.handleSearch} />
                      <ChakraNumberInput
                        onChange={store.handleChangeAmountFrom}
                        size="sm"
                        value={store.amountFromInputValue}
                      >
                        <NumberInputField placeholder={t`Amount from`} />
                      </ChakraNumberInput>
                      <ChakraNumberInput
                        onChange={store.handleChangeAmountTo}
                        size="sm"
                        value={store.amountToInputValue}
                      >
                        <NumberInputField placeholder={t`Amount to`} />
                      </ChakraNumberInput>
                    </HStack>
                    <FiltersPanelFilters menuListZIndex={422} />
                  </HStack>
                </FiltersPanelRoot>
              </Box>
            </DataTable.NavBar>
            <LoadingOverlay
              position="absolute"
              isLoading={store.fetcher.isLoading.value}
            >
              <DataTable.Body
                columns={store.columns}
                data={store.tableData}
                tableKey={store.tableKey}
                selected={store.selectedIds}
                onSelect={store.handleSelect}
                enableRowSelection
              />
            </LoadingOverlay>
            <Pagination store={store.pagination} />
          </DataTable>
        </ModalBody>
        <ModalFooter>
          <HStack justify="end" spacing="2">
            <Button
              colorScheme="grey"
              isLoading={store.isSubmitting}
              onClick={store.disclosure.onClose}
              variant="outline"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              isDisabled={store.isConfirmDisabled}
              isLoading={store.isSubmitting}
              onClick={store.handleConfirm}
            >
              <Trans>Match</Trans>
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
